import { AppDispatch } from '@/store/store';
import { EventType } from '@/models/Interaction';
import { fetchReportStateByWidgetId } from '@/store/thunks/FetchReport';
import { fetchTableStateByWidgetId } from '@/store/thunks/FetchTable';
import { getChatAPI } from '@/api/ChatApi';
import {
  openReportWidget,
  openTableWidget,
} from '@/store/actionCreators/WidgetActions';
import { startNewThreadFromMessage } from '@/actions/QueryActionHelpers';
import { tableWidgetFactory } from '@/models/Table';
import { WidgetEvent, WidgetType } from '@/models/PanelWidgets';

export interface WidgetTriggerContext {
  eventId: string;
  widgetId: string;
  widgetType: WidgetType;
}

export async function dispatchWidgetAction({
  messageId,
  triggerContextObj,
  dispatch,
}: {
  messageId?: string;
  triggerContextObj: WidgetTriggerContext;
  dispatch: AppDispatch;
}): Promise<void> {
  if (!messageId) {
    console.log('Missing message id in deep link');
    return;
  }

  const { eventId, widgetId, widgetType } = triggerContextObj;
  if (!eventId) {
    console.log('Missing event id in deep link');
    return;
  }

  const thread = await startNewThreadFromMessage(messageId, dispatch, eventId);
  if (!thread) {
    return;
  }

  dispatchFetchAndOpenWidgetAction({
    threadId: thread.id,
    widgetType,
    widgetId,
    dispatch,
  });

  const chatApi = getChatAPI();
  chatApi.trackEvent({
    type: EventType.UI_INTERACTION,
    threadId: thread.id,
    messageId: thread.messages[0].id,
    data: {
      widget_type: widgetType,
      event_type: WidgetEvent.WIDGET_OPEN,
      event_id: eventId,
      widget_id: widgetId,
    },
  });
}

export function dispatchFetchAndOpenWidgetAction({
  threadId,
  widgetType,
  widgetId,
  dispatch,
}: {
  threadId: string;
  widgetType: WidgetType;
  widgetId: string;
  dispatch: AppDispatch;
}): void {
  switch (widgetType) {
    case WidgetType.TABLE:
      dispatch(
        openTableWidget({
          currentThreadId: threadId,
          tableData: tableWidgetFactory({ isLoading: true }),
        }),
      );
      dispatch(
        fetchTableStateByWidgetId({
          threadId,
          widgetId,
        }),
      );
      break;
    case WidgetType.REPORT:
      dispatch(
        openReportWidget({
          currentThreadId: threadId,
          reportData: null,
        }),
      );

      dispatch(
        fetchReportStateByWidgetId({
          threadId,
          widgetId,
        }),
      );
      break;
    default:
      console.log(`Unsupported widget type ${widgetType}`);
  }
}
